import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import SimpleAvatarWidget from './SimpleAvatarWidget';
var GREETING_DELAY = 3000; // Show greeting after 3s
var VoiceComponent = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g;
    var position = _a.position, header = _a.header, isOpen = _a.isOpen, onClose = _a.onClose, onToggle = _a.onToggle, email = _a.email, language = _a.language, domain = _a.domain, _h = _a.mode, mode = _h === void 0 ? 'avatar' : _h, _j = _a.themeMode, themeMode = _j === void 0 ? 'dark' : _j, onToggleTheme = _a.onToggleTheme;
    var _k = useState(position.side || 'right'), side = _k[0], setSide = _k[1];
    var _l = useState(false), showGreeting = _l[0], setShowGreeting = _l[1];
    var _m = useState(false), greetingDismissed = _m[0], setGreetingDismissed = _m[1];
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var buttonSize = isMobile ? '3.5rem' : '4rem';
    var iconSize = isMobile ? '1.75rem' : '2rem';
    useEffect(function () {
        setSide(position.side || 'right');
    }, [position.side]);
    // Show greeting bubble after delay (only when widget is closed)
    useEffect(function () {
        if (isOpen || greetingDismissed) {
            setShowGreeting(false);
            return;
        }
        var timer = setTimeout(function () { return setShowGreeting(true); }, GREETING_DELAY);
        return function () { return clearTimeout(timer); };
    }, [isOpen, greetingDismissed]);
    var handleGreetingClick = function () {
        setShowGreeting(false);
        setGreetingDismissed(true);
        onToggle();
    };
    var handleGreetingClose = function (e) {
        e.stopPropagation();
        setShowGreeting(false);
        setGreetingDismissed(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AnimatePresence, null, isOpen && (React.createElement(SimpleAvatarWidget, { isOpen: isOpen, onClose: onClose, side: side, verticalPosition: position.verticalAlign, header: header, domain: 'halfmillion', mode: mode, themeMode: themeMode, onToggleTheme: onToggleTheme }))),
        React.createElement(AnimatePresence, null, showGreeting && !isOpen && (React.createElement(motion.div, { className: "talkbot-greeting-bubble", initial: { opacity: 0, y: 10, scale: 0.92 }, animate: { opacity: 1, y: 0, scale: 1 }, exit: { opacity: 0, y: 6, scale: 0.95 }, transition: { duration: 0.3, ease: [0.34, 1.56, 0.64, 1] }, onClick: handleGreetingClick, style: (_b = {},
                _b[position.side] = ((_d = position.offset) === null || _d === void 0 ? void 0 : _d[position.side]) || '20px',
                _b.bottom = "calc(".concat(((_e = position.offset) === null || _e === void 0 ? void 0 : _e.bottom) || '20px', " + ").concat(buttonSize, " + 16px)"),
                _b) },
            React.createElement("button", { className: "talkbot-greeting-close", onClick: handleGreetingClose, "aria-label": "Dismiss" }, "\u2715"),
            React.createElement("p", null,
                "\uD83D\uDC4B ",
                React.createElement("strong", null, "Need help?"),
                " Click here to chat with our AI assistant!")))),
        React.createElement(motion.button, { className: "talkbot-fab ".concat(isOpen ? 'talkbot-fab--open' : ''), whileHover: { scale: isOpen ? 1 : 1.1 }, whileTap: { scale: isOpen ? 1 : 0.95 }, onClick: onToggle, style: (_c = {
                    position: 'fixed'
                },
                _c[position.side] = ((_f = position.offset) === null || _f === void 0 ? void 0 : _f[position.side]) || '20px',
                _c.bottom = ((_g = position.offset) === null || _g === void 0 ? void 0 : _g.bottom) || '20px',
                _c.width = buttonSize,
                _c.height = buttonSize,
                _c) }, isOpen
            ? React.createElement(X, { style: { width: iconSize, height: iconSize } })
            : React.createElement(MessageCircle, { style: { width: iconSize, height: iconSize } }))));
};
export default VoiceComponent;
